import React, { useState, useCallback } from 'react';
import { Information } from '../modals/common';
import { messageUtility } from '../../utilities/messageUtility';
import Loader from '../Loader';

/**
 * エラーメッセージを閉じる時のタイプ
 * modal_close:モーダル自体を閉じる
 * error_close:エラーメッセージのみ閉じる
 **/
const closeType = {
  modal_close: 1,
  error_close: 2,
};

/**
 * 登録用トークルームヘッダー表示部分
 * @param {function} modalCloseAction モーダル自体を閉じるときに動作する関数
 **/
function useErrorInfomation(modalCloseAction) {
  const initial_state = {
    isError: false,
    errorMessage: '',
    closeType: 0,
  };
  const [errorStatus, setErrorStatus] = useState(initial_state);

  /**
   * エラー情報を表示させる。
   * @param {string} errorMessage 表示するエラーメッセージ
   * @param {number} closeType エラーを閉じる時の種別。定数closeTypeの値を格納すること。
   */
  const displayErrorInfomation = useCallback(
    (errorMessage, closeType) =>
      setErrorStatus(prevstate => {
        if (prevstate.isError === false) {
          // ロード中表示が止まらないことを防止
          Loader.done();
          return { isError: true, errorMessage, closeType };
        } else {
          return prevstate;
        }
      }),
    []
  );

  const closeAction = () => {
    switch (errorStatus.closeType) {
      case closeType.modal_close:
        modalCloseAction();
        break;
      case closeType.error_close:
        setErrorStatus(initial_state);
        break;
    }
  };

  const RenderErrorInfomation = () => {
    return (
      <Information
        title={messageUtility.getMessage('E-001-402')}
        rootClassName='lw-dialog-error'
        message={errorStatus.errorMessage}
        buttonText={messageUtility.getMessage('I-000-017')}
        onClose={closeAction}
        visible={errorStatus.isError}
      />
    );
  };
  return { displayErrorInfomation, RenderErrorInfomation };
}

export { closeType, useErrorInfomation };



// WEBPACK FOOTER //
// ./src/components/lwUser/errorInfomation.jsx